import React from 'react';

import dayjs from "dayjs";

import {CircularProgress} from "@mui/joy";
import Box from '@mui/joy/Box';

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import VacationCreateModal from "./VacationCreateModal";


class VacationList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            vacations: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveVacations();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveVacations();
        }
    }

    async retrieveVacations() {
        const url = 'vacation/';
        const api = new BaseApi();
        let params = {}
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                vacations: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    render() {
        if (!this.state.vacations) {
            return (<CircularProgress/>)
        }
        if (!this.state.pages) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <CommonPaginatedTable
                    title={'Отпуски'}
                    url={'hr/vacation'}
                    data={this.state.vacations}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                    extraComponents={[
                        {
                            component: VacationCreateModal,
                            componentProps: {
                                callBack: this.retrieveVacations.bind(this)
                            }
                        },
                    ]}
                    fields={[
                        {
                            title: 'ФИО',
                            name: ['subscriber.user.first_name', 'subscriber.user.last_name'],
                            visible: true,
                        },
                        {
                            title: 'Начало',
                            name: 'start_date',
                            visible: true,
                            preProcess: (value) => (value?dayjs(value).format('DD.MM.YYYY'):value),
                            edit: {
                                permission: true,
                                fields: ['start_date', ],
                                baseUrl: 'vacation',
                            },
                        },
                        {
                            title: 'Конец',
                            name: 'end_date',
                            visible: true,
                            preProcess: (value) => (value?dayjs(value).format('DD.MM.YYYY'):value),
                            edit: {
                                permission: true,
                                fields: ['end_date', ],
                                baseUrl: 'vacation',
                            },
                        },
                        {
                            title: 'Согласован',
                            name: 'is_approved',
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['is_approved', ],
                                baseUrl: 'vacation',
                            },
                        },
                        {
                            title: 'Тип',
                            name: 'xtype_human',
                            visible: true,
                            chip: true,
                            color_rule: (value, comparison) => (value),
                            color_value: 'color',
                        },
                        {
                            title: 'ФИО заместителя',
                            name: ['replacement_subscriber.user.first_name', 'replacement_subscriber.user.last_name'],
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['replacement_subscriber', ],
                                baseUrl: 'vacation',
                            },
                        },
                    ]
                    }
                />
            </Box>
        )
    }
}

export default withRouter(VacationList)